import DataFetcherTemplateHome from "../../hooks/DataFetcherTemplateHome";

import ConectUs from "../../components/ConectUs";

import { motion } from "framer-motion";

import ImageGallery from "../../components/ImageGallery";

import DescuentosEnlinea from "./DescuentosEnlinea";
import BlockRightImage from "../../components/BlockRightImage";
import OfferLinea from "../../components/view/OfferLinea";

const url =
  "https://be-ofertas.utpl.edu.ec/jsonapi/node/template_home/8d79aff7-681f-4fa5-abaa-bd7557bcbe50" +
  "?include=field_imagen_portada.field_media_image,field_gallery.field_media_image,field_imagen1.field_media_image" +
  "&fields[node--template_home]=title,field_gallery,field_imagen_portada,field_imagen1,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4" +
  "&fields[media--image]=field_media_image" +
  "&fields[file--file]=uri";

function Home() {
  const processContent = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    doc.querySelectorAll("img").forEach((img) => {
      const src = img.getAttribute("src");

      if (src && !src.startsWith("http")) {
        img.setAttribute(
          "src",
          `https://be-ofertas.utpl.edu.ec/${src.replace(/^\/+/, "")}`,
        );
      }
    });

    return doc.body.innerHTML;
  };

  const DataDisplay = ({ data }) => (
    <div>
      {data.bloque1 && (
        <div
        className="max-w-3xl m-auto mt-10"
          dangerouslySetInnerHTML={{
            __html: processContent(data.bloque1),
          }}
        />
      )}
    </div>
  );

  return (
    <>
      <DataFetcherTemplateHome url={url}>
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplateHome>
 
    </>
  );
}

export default Home;
